// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#countdown[data-v-4047f503]{cursor:default}#countdown span[data-v-4047f503]{font-size:12px;color:#141c20}#countdown .hourglass[data-v-4047f503]{margin-right:5px;font-size:10px}#countdown .time-left[data-v-4047f503]{font-size:14px}#countdown .time-left.initializing[data-v-4047f503]{color:#9eafb5}#countdown-popover[data-v-4047f503]{max-width:234px;margin-left:0}", ""]);
// Exports
module.exports = exports;
